import styled from 'styled-components';

const CenteredWithMargins = styled.div.attrs({
  className: 'd-flex justify-content-center',
})``;

export { CenteredWithMargins };
